import {
  TERM_LINK_SEARCH,
  TERM_LINK_NETWORK,
  TERM_LINK_SOCIAL
} from '../constants/AdvertisingBriefs/urls'
import { BRIEF_TYPE } from '@src/constants/AdvertisingBriefs'

export const createTermLink = (briefType: number) => {
  switch (briefType) {
    case BRIEF_TYPE.SEARCH:
      return TERM_LINK_SEARCH
    case BRIEF_TYPE.NETWORK:
      return TERM_LINK_NETWORK
    case BRIEF_TYPE.SOCIAL:
      return TERM_LINK_SOCIAL
    default:
      return TERM_LINK_SEARCH
  }
}
